import React, { useEffect, useRef, useState } from "react";
import {
  ColorIcon,
  colors,
  VStack,
  NextLink,
  responsive,
  Button,
  HStack,
  useResponsive,
} from "goi_common";
// import HeroSection from "./compnents/HeroSection";
// import BenefitSection from "./compnents/BenefitSection";

import ReviewSection from "./compnents/ReviewSection";
import Footer from "./compnents/Footer";

import ProductPaymentProcessImage from "@/containers/registration/components/ProductPriceContainer/ProductPaymentProcessImage";

import { Flex, Box } from "@chakra-ui/react";

import { 가족장2026 } from "goi_common/src/constants/servicePackages/service2026/가족장";
import { 무빈소장2026 } from "goi_common/src/constants/servicePackages/service2026/무빈소장";
import { 일반장2026 } from "goi_common/src/constants/servicePackages/service2026/일반장";

// import LandingFixedButton from "@/components/common/LandingFixedButton";
import { sessionStorage, storageKeys } from "@/utils/storage";
import NewHeroSection from "./compnents/NewHeroSection";
import NewBenefitSection from "./compnents/NewBenefitSection";
import LandingFixedTwinButton from "@/components/common/LandingFixedTwinButton";
import useIntersectionObserver from "goi_common/src/hooks/useIntersectionObserver";
import CompareSection from "./compnents/CompareSection";
import FAQSection from "./compnents/FAQSection";

import { keyframes } from "@emotion/react";
import { useRouter } from "next/router";
import ConsultFAB from "@/components/consult/ConsultFAB";
import { useTossPromotionMessage } from "../hooks/useTossPromotionMessage";
import useFunnelRouteDeclare from "@/hooks/useFunnelRouteDeclare";
import { landingFunnelKey } from "@/constants/funnelRouteDeclareValues";
import { PRODUCT_GROUP } from "@/constants/productKey";

const bounceAnimation = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

export default function HomeV2Container() {
  const [isHeroSectionVisible, setIsHeroSectionVisible] = useState(true);
  // const { openModal } = useNoticeModal({ isToss: true });

  const [isArrowVisible, setIsArrowVisible] = useState(true);
  const [isConsultFABVisible, setIsConsultFABVisible] = useState(false);

  const heroSectionRef = useRef<HTMLDivElement>(null);
  const compareSectionRef = useRef<HTMLDivElement>(null);

  const router = useRouter();
  const { isPayCoupon } = router.query;
  const isPayCouponProcess = isPayCoupon === "true";

  // 토스 플랫폼 마킹 및 쿠폰 정보 저장
  useEffect(() => {
    sessionStorage.set(storageKeys.Platform, "toss");
    if (isPayCoupon === "true") {
      sessionStorage.set(storageKeys.isPayCoupon, "true");
    }
    sessionStorage.set("firstVisitPath", "home");
  }, [isPayCoupon]);

  // useEffect(() => {
  //   openModal();
  // }, []);

  // 프로모션 메시지 생성
  const { title, benefit, showNotice } = useTossPromotionMessage();

  // funnel 경로 가져오기
  const { paths } = useFunnelRouteDeclare({
    uniqueKey: landingFunnelKey.GROUP["toss_100"],
  });

  // V4와 동일한 CTA 링크 생성 로직
  const getCtaHref = () => {
    const targetPath =
      paths["product-intro"] ||
      `/registration/product-intro/?productGroup=${PRODUCT_GROUP["100"]}&fnk=toss`;
    const queryParams = isPayCouponProcess ? "isPayCoupon=true" : "";

    if (!queryParams) return targetPath;

    return `${targetPath}${targetPath.includes("?") ? "&" : "?"}${queryParams}`;
  };

  const ctaHref = getCtaHref();

  useIntersectionObserver({
    root: null,
    target: heroSectionRef,
    onIntersect: () => {
      setIsHeroSectionVisible(false);
      setIsArrowVisible(false);
    },
    onNotIntersect: () => {},
    threshold: 0.1,
  });

  useIntersectionObserver({
    root: null,
    target: compareSectionRef,
    onIntersect: () => {
      setIsConsultFABVisible(true);
    },
    threshold: 0.1,
  });

  return (
    <VStack css={{ color: colors.white, overflowX: "hidden" }}>
      {/* <HeroSection href={"/registration/info/"} /> */}
      {isPayCouponProcess && (
        <VStack
          css={{
            background: colors.orange100,
            padding: "10px 0 10px",
            alignItems: "center",
          }}
        >
          <Box
            css={{
              background: colors.orange650,
              padding: "16px 18px",
              width: "fit-content",
              borderRadius: "10px",
              fontSize: "17px",
              color: colors.white,
            }}
          >
            <b>토스페이에서 오셨군요!</b>
            <p
              css={{
                fontSize: "15px",
                lineHeight: "20px",
                padding: "6px 0 0",
              }}
            >
              {title}
              <br /> 고이 상조를 3만원 일시납으로 가입하면
              <br /> {benefit} 드려요 🙌
              {showNotice && (
                <Box className="caption_12_m" marginTop="6px">
                  *해지 시 적립 포인트는 환수돼요.
                </Box>
              )}
            </p>
          </Box>
        </VStack>
      )}

      <NewHeroSection href={ctaHref} />

      {/* <BenefitSection />  */}

      <NewBenefitSection />

      <div ref={heroSectionRef}></div>

      <ServiceSection />

      {/* <AboutSection /> */}
      <div ref={compareSectionRef}>
        <CompareSection />
      </div>

      <ReviewSection />
      {/* <NumberOneSection />
      <CollaborationSection />
      <PRSection /> */}
      <FAQSection />

      <Footer />
      {!isHeroSectionVisible && (
        <LandingFixedTwinButton
          color={colors.orange650}
          text="100원 상조로 장례 준비하기"
          href={ctaHref}
        />
      )}

      {isArrowVisible && (
        <Box
          position="fixed"
          bottom="32px"
          right="0px"
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="0px"
          justifyContent="center"
          width="100%"
          zIndex={1000}
          animation={`${bounceAnimation} 1.5s infinite`}
        >
          <VStack>
            <ColorIcon
              name="arrow_right_small"
              css={{
                transform: "translateY(0px) translateX(20px)",
                rotate: "90deg",
              }}
              size={34}
              color={colors.warmGray550}
            />
            <ColorIcon
              name="arrow_right_small"
              css={{ transform: "translateY(0px)", rotate: "90deg" }}
              size={34}
              color={colors.warmGray550}
            />
          </VStack>
        </Box>
      )}
      {isConsultFABVisible && <ConsultFAB mainColor={colors.orange650} />}

      {/* {isVariationA && (
        <LandingFixedButton
          color={colors.brown650}
          text="100원 상조로 장례 준비하기"
          href={"/registration/info/"}
        />
      )} */}
    </VStack>
  );
}

const services = ["무빈소장" as const, "가족장" as const, "일반장" as const];
const servicePackagesDetail = {
  무빈소장: 무빈소장2026,
  가족장: 가족장2026,
  일반장: 일반장2026,
};
const items = [
  "가격" as const,
  "접객도우미" as const,
  "장례 용품" as const,
  "장의 차량" as const,
];
const suffix: Partial<Record<typeof items[number], string>> = {
  가격: "만 원",
  "장의 차량": "대",
};

function ServiceSection() {
  const { isBiggerThanLg } = useResponsive();
  return (
    <VStack
      width="100%"
      alignItems="center"
      background={colors.gray50}
      id="benefit"
      css={responsive({
        padding: {
          base: "40px 24px 60px",
          lg: "80px 24px",
        },
      })}
    >
      <ColorIcon
        name="icon-match-file"
        color=""
        size={isBiggerThanLg ? 66 : 56}
      />
      <Box
        className="gray900"
        css={responsive({
          fontSize: { base: "24px", lg: "42px" },
          paddingTop: { base: "10px", lg: "16px" },
          fontWeight: "bold",
        })}
        id="service"
      >
        100원 상조 서비스 상세
      </Box>
      <Box
        className="gray600"
        css={responsive({
          fontSize: { base: "14px", lg: "21px" },
          padding: { base: "20px 0px", lg: "40px 0px 20px" },
          textAlign: "center",
        })}
      >
        <b>
          장례 발생시 무빈소장, 가족장, 일반장 중{" "}
          <br className="lg_over_hidden" />
          상품을 선택
        </b>
        하시면 되며, <br />월 100원으로 현재 상품 가격을{" "}
        <br className="lg_over_hidden" />
        장례 시점까지 보장받을 수 있습니다.
      </Box>

      <Box
        css={responsive({
          width: "100%",
          maxWidth: { base: "360px", lg: "600px" },
        })}
      >
        <ProductPaymentProcessImage />
      </Box>

      <HStack
        gap={isBiggerThanLg ? "20px" : "10px"}
        css={responsive({
          margin: { base: "0px 0 20px", lg: "20px 0 40px" },
        })}
      >
        {services.map((name) => (
          <VStack
            gap={isBiggerThanLg ? "4px" : "0px"}
            key={name}
            alignItems="center"
          >
            <Flex
              id={name}
              css={responsive({
                minHeight: "55px",
                color: colors.brown650,
                alignItems: "center",
                fontSize: { base: "16px", lg: "21px" },
                fontWeight: "600",
              })}
            >
              {name}
            </Flex>
            <VStack
              borderRadius={10}
              gap={isBiggerThanLg ? 30 : 20}
              background={colors.white}
              boxShadow={"0px 0px 12px 0px rgba(0, 0, 0, 0.1)"}
              flexGrow={1}
              css={responsive({
                width: { base: "105px", lg: "190px" },
                padding: { base: "16px 8px", lg: "24px 13px" },
              })}
            >
              {items.map((a) => (
                <VStack key={a} alignItems="center">
                  <div
                    css={responsive({
                      color: colors.gray600,
                      fontSize: { base: "12px", lg: "16px" },
                    })}
                  >
                    {a}
                  </div>
                  <div
                    className="subtitle_14_b lg_subtitle_18_b"
                    css={responsive({
                      fontSize: { base: "14px", lg: "18px" },
                      color: colors.gray800,
                    })}
                  >
                    {servicePackagesDetail[name][a]}
                    {suffix[a]}
                  </div>
                </VStack>
              ))}
            </VStack>
          </VStack>
        ))}
      </HStack>

      <NextLink
        href="/service/"
        event={{
          newGtm: { path: "home", trigger_and_target: "uv_service" },
        }}
      >
        <Button
          className="body_16_m md_head_24_m"
          css={responsive({
            border: `1px solid ${colors.gray200}`,
            borderRadius: "12px",
            background: colors.white,
            color: colors.gray900,
            padding: { base: "12px 20px", md: "16px 33px" },
            marginTop: { base: "24px", md: "40px" },
          })}
        >
          상품 자세히 보기
        </Button>
      </NextLink>
    </VStack>
  );
}
